export default __webpack_public_path__ + "static/media/shopping-cart.42e193be.svg";